module.exports = require("core-js-pure/stable/instance/reduce");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/reduce.js
// module id = 6446
// module chunks = 25